import type { ButtonHTMLAttributes } from 'react'

type Variant = 'primary' | 'navy' | 'ghost' | 'danger'
type Size = 'sm' | 'md' | 'lg'

/** primary = gold page-level action, navy = in-panel action, ghost/danger = light-area secondary. */
const variants: Record<Variant, string> = {
  primary:
    'bg-ostrel-gold text-ostrel-navy font-semibold uppercase tracking-wider hover:bg-ostrel-accent disabled:bg-ostrel-dim',
  navy:
    'bg-ostrel-navy text-ostrel-light font-semibold uppercase tracking-wider hover:bg-ostrel-raised disabled:bg-ostrel-dim',
  ghost:
    'border border-ostrel-line bg-ostrel-card text-ostrel-ink uppercase tracking-wider hover:bg-ostrel-sand disabled:text-ostrel-dim',
  danger:
    'border border-ostrel-danger bg-ostrel-card text-ostrel-danger uppercase tracking-wider hover:bg-ostrel-danger/10 disabled:border-ostrel-line disabled:text-ostrel-dim',
}

const sizes: Record<Size, string> = {
  // max-md: >=40px touch targets on phones/tablets, desktop density unchanged.
  sm: 'px-2.5 py-1 text-[11px] max-md:min-h-10 max-md:px-3.5',
  md: 'px-4 py-2 text-xs max-md:min-h-10',
  lg: 'px-6 py-3 text-sm',
}

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant
  size?: Size
}

export function Button({ variant = 'primary', size = 'md', className = '', ...rest }: ButtonProps) {
  return (
    <button
      className={`rounded-sm transition-colors focus:outline-none focus:ring-2 focus:ring-ostrel-gold disabled:cursor-not-allowed ${variants[variant]} ${sizes[size]} ${className}`}
      {...rest}
    />
  )
}
